import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const UpgradePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "UpgradePopup" */ './View'),
  'popup'
);
